export default "__VITE_ASSET__e7444ac1__"